import { gql } from 'apollo-boost';
import { SettingsContext } from 'core/components/settingsContext';
import { useIdsFromUrl } from 'core/hooks/useIdsFromUrl';
import { useContext, useMemo } from 'react';
import { ProductAdminVisibilityEnum, ProductListRequest, useGetLecturerQuery } from 'site/graphql';

gql`
    query GetLecturer($id: Int!, $productsFilter: ProductListRequest) {
        lecturer(id: $id) {
            id
            education
            skill
            about
            account {
                id
                firstName
                lastName
                middleName
                pictureId
            }
            products(filter: $productsFilter) {
                id
                name
            }
        }
    }
`;

const useLecturerData = () => {
    const { teacherId } = useIdsFromUrl('teacherId');
    const settings = useContext(SettingsContext);

    const productsFilter = useMemo<ProductListRequest>(
        () => ({
            contentProviderId: settings.contentProviderId,
            visibility: ProductAdminVisibilityEnum.Public,
            full: true,
        }),
        [settings],
    );

    const { data, loading, error } = useGetLecturerQuery({ variables: { id: Number(teacherId), productsFilter } });
    const lecturer = data && data.lecturer;

    return [lecturer, loading, error] as const;
};

export default useLecturerData;
